import { createContext } from "react";

import { IContextEp } from "@/context/ep/types";

export const ContextEp = createContext<IContextEp>(
  null as unknown as IContextEp,
);
